<template>
  <div>
    <modal-crear-editar
      :configuracion="configuracion_modal"
      @realizado="restablecer_inputs"
    ></modal-crear-editar>
    <tablita
      @cargar="cargar($event)"
      @cargar_url="cargar_url($event)"
      @nuevo="crear"
      @editar="editar($event)"
      :configuracion="configuracion_tabla"
      @detalle="detalle"
      @refresh="refrescar($event)"
      :cols="columnas"
    ></tablita>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import ModalCrearEditar from "../../components/Modal/ModalEditarCrear";
import Tabla from "../../components/Tabla/Tabla";
//import lenguaje from '../../config/es_datatable.json'
export default {
  data: () => ({
    filter: "",
    columnas: [
      {
        key: "empresas_id",
        label: "Empresa",
        busqueda: "",
        tipo: "select",
        searchable: true,
        path: "empresa.nombre",
        opciones: [],
        valor_opcion: "id",
        label_opcion: "nombre",
      },
      {
        key: "anio",
        label: "Periodo",
        busqueda: "",
        tipo: "select",
        searchable: true,
        path: "anio",
        opciones: [],
        valor_opcion: "anio",
        label_opcion: "anio",
      },
    ],
    botones: [
      {
        label: "Editar",
        clase: "btn-warning",
        evento: "editar",
        icono: "fa fa-pen",
      },
      {
        label: "Detalle",
        clase: "btn-primary",
        evento: "detalle",
        icono: "fas fa-search-plus",
      },
    ],
    lista: [],
    links: [],
    inputs: [
      {
        cols: 6,
        tipo: "select",
        key: "empresas_id",
        valor: "",
        label: "Seleccione Empresa (*)",
        opciones: [],
        valor_opcion: "id",
        label_opcion: "nombre",
      },
      {
        cols: 6,
        tipo: "select",
        key: "anio",
        valor: "",
        label: "Periodo (*)",
        opciones: [],
        valor_opcion: "anio",
        label_opcion: "anio",
      },
    ],
    configuracion_modal: {
      titulo: "Registrar Proyeccion",
      ancho: "lg",
      ruta: "/proyecciones",
      tipo_ruta: "post",
      titulo_boton: "Crear",
      clase_boton: "btn-success",
    },
    configuracion_tabla: {
      titulo: "Listado de Proyecciones",
      titulo_boton: "Crear Proyeccion",
      clase_boton: "btn-primary",
      btn_nuevo: true,
    },
    pagina_actual: "",
    periodos: [],
    empresas: [],
  }),
  mounted() {
    this.inicializar_tabla({
      columnas: [],
      lista: [],
      links: [],
      botones: [],
      botones_restringidos: [],
    });
    let storage = localStorage.getItem(this.path);
    if (storage) {
      storage = JSON.parse(storage);
      this.columnas.forEach((col) => {
        col.busqueda = storage.columnas.find((c) => c.key == col.key).val;
      });
    }
    this.$emit("spinner", true);
    this.cargarPeriodos();
  },
  methods: {
    refrescar() {
      localStorage.removeItem(this.path);
      this.columnas.forEach((c) => {
        if (
          [
            "string",
            "number",
            "select",
            "select-loadable",
            "select-loadable-dependiente",
            "datetime",
            "html",
            "html_select",
          ].includes(c.tipo)
        ) {
          c.busqueda = "";
        }

        if (["multiselect"].includes(c.tipo)) {
          c.busqueda = [];
        }
      });
      this.$emit("cargar");
    },
    async cargar($event) {
      this.$emit("spinner", true);
      this.pagina_actual = `${this.api}/proyecciones${$event}`;
      this.lista = [];
      await this.axios
        .get(`${this.api}/proyecciones${$event}`, this.cabeceras_json)
        .then((res) => {
          this.lista = res.data.data.data;
          this.links = res.data.data.links;

          this.inicializar_tabla({
            columnas: this.columnas,
            lista: this.lista,
            links: this.links,
            botones: this.botones,
          });
        })
        .catch((e) => {
          //alert(e);
        });
      this.$emit("spinner", false);
    },
    async cargar_url(url) {
      if (url) {
        this.$emit("spinner", true);
        this.pagina_actual = url;
        await this.axios
          .get(url, this.cabeceras_json)
          .then((res) => {
            this.lista = res.data.data.data;
            this.links = res.data.data.links;
            ////console.log('listado',res.data.data.data);
            this.setear_lista({ lista: this.lista, links: this.links });
            //$('#empresas').DataTable().draw();
          })
          .catch((e) => {
            //alert(e);
          });
        this.$emit("spinner", false);
      }
    },

    cargarPeriodos() {
      let min = new Date().getFullYear();
      let max = min + 10;

      for (var i = min; i <= max; i++) {
        this.periodos.push({ anio: i });
      }

      this.inputs[1].opciones = this.periodos;
      this.columnas[1].opciones = this.periodos;
      this.cargarEmpresas();
    },

    async cargarEmpresas() {
      await this.axios
        .get(
          `${this.api}/empresas?tipo_empresa_ids=4&limit=99999999`,
          this.cabeceras_json
        )
        .then((res) => {
          //console.log('empresas',res.data.data.data);
          this.empresas = res.data.data.data;
          this.inputs[0].opciones = this.empresas;
          this.columnas[0].opciones = this.empresas;
        })
        .catch((e) => {
          //console.log(e);
        });
      //this.cargar("");
      this.$emit("cargar");
    },

    crear() {
      this.setear_inputs(this.inputs);
      this.configuracion_modal.ruta = `/proyecciones`;
      this.configuracion_modal.tipo_ruta = "post";
      this.configuracion_modal.titulo_boton = "Crear";
      this.configuracion_modal.clase_boton = "btn-success";

      this.$emit("abrir", { inputs: this.inputs });
    },

    editar(evento) {
      //console.log('evento',evento);
      let item = evento.item;
      this.inputs.forEach((i) => {
        //recorrido del objeto a editar
        Object.keys(item).forEach((key) => {
          let valor = item[key];
          if (i.key == key) {
            i.valor = valor;
          }
        });
      });
      this.setear_inputs(this.inputs);
      this.configuracion_modal.ruta = `/proyecciones/${evento.item.id}`;
      this.configuracion_modal.tipo_ruta = "put";
      this.configuracion_modal.titulo_boton = "Actualizar";
      this.configuracion_modal.clase_boton = "btn-warning";

      this.$emit("abrir");
    },
    restablecer_inputs() {
      this.cargar_url(this.pagina_actual);
      this.inputs.forEach((i) => {
        i.valor = "";
      });
      this.setear_inputs(this.inputs);
    },
    ...mapActions(["inicializar_tabla", "setear_lista", "setear_inputs"]),

    detalle(event) {
      //console.log(event);
      this.$router.push({
        name: "proyeccion_detalle",
        params: { id: event.item.id },
      });
    },
  },
  components: {
    "modal-crear-editar": ModalCrearEditar,
    tablita: Tabla,
  },
  computed: {
    ...mapState(["api", "cabeceras_json"]),
    query() {
      let string = "?";
      let and = "";
      let total = this.columnas.length - 1;
      this.columnas.forEach((c, index) => {
        if (index > 0 && string.length > 0) {
          and = "&";
        } else if (index == total) {
          and = "";
        }

        if (c.busqueda != "") {
          string += `${and}${c.key}=${c.busqueda}`;
        }
      });
      return string;
    },
    path() {
      return this.$router.currentRoute.path;
    },
  },
};
</script>
<style>
.form-control {
  height: calc(1em + 1.25rem + 5px);
}
</style>